import React from 'react';
import Header from './Header';
import { useAuth } from '../contexts/AuthContext';

const Layout = ({ children }) => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      {isAuthenticated && <Header />}
      <main className={isAuthenticated ? 'main-content with-header' : 'main-content'}>
        {children}
      </main>
    </>
  );
};

export default Layout;